import React, { useEffect } from "react";
import { default as ReactModal } from "react-modal";
import "./style.scss";

ReactModal.setAppElement(document.getElementById("root"));

function Modal({ children, isOpen, ...rest }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div>
      <ReactModal isOpen={isOpen} {...rest} portalClassName="ReactModal-chat">
        <div className="ReactModal">{children}</div>
      </ReactModal>
    </div>
  );
}

export default Modal;
